"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDurationInYears = exports.mapPropositionDuration = exports.mapDuration = void 0;
const offerstore_api_models_1 = require("@integration/offerstore-api-models");
const base_models_1 = require("@integration/base-models");
const map = {
    [offerstore_api_models_1.PropositionDuration['1YEAR']]: base_models_1.DurationInYears.ONE,
    [offerstore_api_models_1.PropositionDuration['2YEARS']]: base_models_1.DurationInYears.TWO,
    [offerstore_api_models_1.PropositionDuration['3YEARS']]: base_models_1.DurationInYears.THREE,
    [offerstore_api_models_1.PropositionDuration['5YEARS']]: base_models_1.DurationInYears.FIVE,
    [offerstore_api_models_1.PropositionDuration.FLEX]: base_models_1.DurationInYears.FLEX,
    [offerstore_api_models_1.PropositionDuration.OBT]: base_models_1.DurationInYears.FLEX,
};
exports.mapDuration = {
    [base_models_1.DurationInYears.ONE]: offerstore_api_models_1.PropositionDuration['1YEAR'],
    [base_models_1.DurationInYears.TWO]: offerstore_api_models_1.PropositionDuration['2YEARS'],
    [base_models_1.DurationInYears.THREE]: offerstore_api_models_1.PropositionDuration['3YEARS'],
    [base_models_1.DurationInYears.FIVE]: offerstore_api_models_1.PropositionDuration['5YEARS'],
    // There is some discrepancies regarding the coding of flex
    // In the frontend is it called FLEX or flex, but SAP calls it OBT (onbepaalde tijd) or 99
    // There is also 98 which is called flex by SAP.
    [base_models_1.DurationInYears.FLEX]: offerstore_api_models_1.PropositionDuration.OBT,
};
const mapPropositionDuration = (duration) => map[duration];
exports.mapPropositionDuration = mapPropositionDuration;
const mapDurationInYears = (duration) => exports.mapDuration[duration];
exports.mapDurationInYears = mapDurationInYears;
